import { Box, Progress } from "@carrotfertility/carotene-core"
import React from "react"

export const CenteredLoadingIndicator = ({ id = "centered-loading-indicator", ...otherProps }) => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    flex={"auto"}
    padding={(theme) => theme.spacing(theme.tokens.spacing.lg)}
    {...otherProps}
  >
    <Progress id={id} data-testid={"centered-loading-indicator"} />
  </Box>
)
